import React from 'react';
import { useAuth } from "../lib/auth.tsx";
import { Navigate } from 'react-router-dom';
import { CreatorDashboard } from "../components/CreatorDashboard.tsx";

export function CreatorDashboardPage() {
  const { user, loading } = useAuth();

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-100 py-8">
        <div className="container mx-auto px-4 max-w-7xl">
          <div className="flex items-center justify-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-wayja-teal"></div>
          </div>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/auth/login" replace />;
  }

  return (
    <div className="min-h-screen bg-gray-100 py-8 pb-16">
      <div className="container mx-auto px-4 max-w-7xl">
        <CreatorDashboard />
      </div>
    </div>
  );
} 